export const MAGICLINK_CLASSNAME = 'magiclinks';

export const YFM_COLORIFY_MARKDOWN_CLASSNAME = 'yfm-colorify';

export const enum YfmQa {
    WrapperHtml = 'yfm-wrapper-html',
}

export const enum YfmTokenTypes {
    TemplateOpen = 'template_open',
    DefinitionOpen = 'dfn_open',
    TermOpen = 'term_open',
    Inline = 'inline',
}

export const enum YfmAttributes {
    Id = 'id',
    TermKey = 'term-key',
    AriaDescribedby = 'aria-describedby',
}

export const YfmMetaScripts = {
    LATEX: 'extension:latex',
    MERMAID: 'extension:mermaid',
};
